// import {getFirebase} from "react-redux-firebase"
// import {getFirestore} from 'redux-firestore'
import firebase from 'firebase'
import moment from 'moment'
import * as Sentry from '@sentry/react'
import {NotificationContainer, NotificationManager} from 'react-notifications'

// export const subscribeToProduct = (subscriptionStatus) => {
//     return (dispatch, getState, getFirebase) => {
//         const subscribed = subscriptionStatus
//         console.log('firebase: ', getFirebase())
//         dispatch({type: 'SET_SUBSCIPRTION_STATUS', subscribed})
//     }
// }

export const signOut = () => {
    return (disptach, getState, getFirebase) => {
        getFirebase().auth().signOut()
        .then(()=>disptach({type: 'SIGN_OUT'}))
    }
}

export const signUpWithEmailAndPassword = (email, password, name) => {
    return (dispatch, getState, getFirebase) => {
        return new Promise(async(resolve,reject) => {
            getFirebase().auth().createUserWithEmailAndPassword(email, password)
            .then(resp => {
                if (resp.user) {
                    const payload = {
                        uid: resp.user.uid,
                        accountType: 'password',
                        name: name,
                        emailAddress: email,
                        createdAt: Date.now(),
                        lastLoggedIn: Date.now()
                    }
                    dispatch(createUserProfile(payload))
                    resolve({success: true})
                }
            })
            .catch(err => {
                console.log(err)
                reject(err.message)
            })
        })
    }
}

export const signInWithEmailAndPassword = (email, password) => {
    return (dispatch, getState, getFirebase) => {
        return new Promise(async(resolve, reject) => {
            getFirebase().auth().signInWithEmailAndPassword(email, password)
            .then(resp => {
                if (resp.user) {
                    dispatch(updateLastLoggedIn(resp.user.uid))
                    resolve({success: true})
                }
            })
            .catch(err => {
                reject(err.message)
                console.log(err)
            })
        })
    }
}

export const signInWithGoogle = () => {
    return (dispatch, getState, getFirebase) => {
        return new Promise(async(resolve, reject) => {
            const provider = new firebase.auth.GoogleAuthProvider();
            getFirebase().auth().signInWithPopup(provider).then((result)=>{
                if (result.user) {
                    if (result.additionalUserInfo.isNewUser) {
                        //NEW USER, CREATE PROFILE IN FIREBASE
                        const payload = {
                            uid: result.user.uid,
                            accountType: 'google.com',
                            name: result.user.displayName,
                            emailAddress: result.user.email,
                            profilePicture: result.user.photoURL,
                            createdAt: Date.now(),
                            lastLoggedIn: Date.now(),
                        }
                        dispatch(createUserProfile(payload))
                    }
                    dispatch(updateLastLoggedIn(result.user.uid))
                    resolve({success: true})
                }
                else {
                    reject('No user found')
                }
            }).catch(function(error) {
                console.log('error: ', error)
                reject(error.message)
            });
        })

    }
}

export const signInWithFacebook = () => {
    return (dispatch, getState, getFirebase) => {
        return new Promise(async(resolve, reject) => {
            const provider = new firebase.auth.FacebookAuthProvider();
            getFirebase().auth().signInWithPopup(provider).then((result)=>{
                if (result.user) {
                    if (result.additionalUserInfo.isNewUser) {
                        //NEW USER, CREATE PROFILE IN FIREBASE
                        const payload = {
                            uid: result.user.uid,
                            accountType: 'google.com',
                            name: result.user.displayName,
                            emailAddress: result.user.email,
                            profilePicture: result.user.photoURL,
                            createdAt: Date.now(),
                            lastLoggedIn: Date.now(),
                        }
                        dispatch(createUserProfile(payload))
                    }
                    dispatch(updateLastLoggedIn(result.user.uid))
                    resolve({success: true})
                }
                else {
                    reject('No user found')
                }
            }).catch(function(error) {
                console.log('error: ', error)
                reject(error.message)
            });
        })

    }
}

export const updateLastLoggedIn = (uid) => {
    return (dispatch, getState, getFirebase) => {
        getFirebase().firestore().collection("users").doc(uid).set({
            lastLoggedIn: Date.now()
        }, {merge: true})
    }
}

export const sendForgotPasswordEmail = (email) => {
    return (dispatch, getState, getFirebase) => {
        return new Promise(async(resolve, reject) => {
            getFirebase().auth().sendPasswordResetEmail(email)
            .then(resolve({success: true}))
            .catch(err => reject(err))
        })
    }
}

export const fetchUserProfile = (uid) => {
    return (dispatch, getState, getFirebase) => {
        return new Promise(async(resolve, reject) => {
            getFirebase().firestore().collection("users").doc(uid).get()
            .then(resp =>{
                const payload = resp.data()
                dispatch({type: 'SET_USER_PROFILE', payload})
                dispatch(checkSubscriptionStatus(uid))
            })
            .catch(err=>{console.log('ERROR!!!!!'); console.log(err)})
        })
    }
}

export const createUserProfile = (payload) => {
    return async (dispatch, getState, getFirebase) => {
        getFirebase().firestore().collection("users").doc(payload.uid).set({...payload})
        .catch(err => {
            console.log(err)
            Sentry.captureException(`Error creating profile in firestore: ${err} with payload: ${payload}`);
        })
    }
}

export const checkSubscriptionStatus = (uid) => {
    return async(dispatch, getState, getFirebase) => {
        const sandboxMode = process.env.NODE_ENV === 'development' ? true : false
        await fetch(`https://api.revenuecat.com/v1/subscribers/${uid}?sandbox_mode=${sandboxMode}`, {
            method: 'GET',
            headers: {
                'content-type': 'application/json',
                'authorization': 'BEARER RpBnIkmxHsDScWqmpvcCOIbugbKiFBEJ'
            }
        })
        .then(resp => {return resp.json()})
        .then(data => {
            const payload = data
            dispatch({type: 'SET_SUBSCRIPTION_DATA', payload})
            let subscribed = false
            if (data.subscriber.entitlements.full_access) {
                const expirationDate = moment.utc(data.subscriber.entitlements.full_access.expires_date, '')
                const today = moment.utc(data.request_date, '')
                const expired = today.isAfter(expirationDate)
                if (!expired) {
                    subscribed = true
                }
            }
            dispatch({type: 'SET_SUBSCRIPTION_STATUS', subscribed})
        })
        .catch(err => console.log(err))
    }
}

export const toggleSubscription = () => {
    return async (dispatch, getState, getFirebase) => {
        return new Promise(async(resolve,reject) => {
            const body = {
                user_id: getState().firebaseReducer.auth.uid,
                user_email: getState().firebaseReducer.auth.email,
                product_id: getState().user.subscribeData.subscriber.entitlements.full_access.product_identifier,
            };
    
            await fetch('https://us-central1-poddecks.cloudfunctions.net/subscribe/update', {
                method: 'POST',
                body: JSON.stringify(body)
            }).then(function(response) {
                return response.json();
            }).then(function(data) {
                if (data.statusCode === 500) {
                    reject(JSON.parse(data.body).error)
                }
                else {
                    resolve({success: true})
                }
            }).catch(err => reject(err))
        })
    }
}

export const setActivePlanChoice = (plan) => {
    return async (dispatch) => {
        dispatch({type: 'SET_ACTIVE_PLAN_CHOICE', plan})
    }
}

export const setAuthLoaded = (loaded) => {
    return async (dispatch) => {
        dispatch({type: 'SET_AUTH_LOADED', loaded})
    }
}

export const fetchContestList = () => {
    console.log('fetching contest data')
    return async (dispatch, getState, getFirebase) => {
        return new Promise(async(resolve,reject) => {
            // const uid = getState().firebaseReducer.auth.uid
            const data = []
            getFirebase().firestore().collection("contestEntries").get()
            .then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    data.push(doc.id)
                });
                console.log('contest data: ', data)
                resolve({success: data})
            })
            .catch(err=>{
                console.log(err)
                reject({error: err})
            })
        })
    }
}

export const fetchContestData = (contestId) => {
    return async (dispatch, getState, getFirebase) => {
        return new Promise(async(resolve,reject) => {
            let results = []
            getFirebase().firestore().collection("contestEntries").doc(contestId).collection("entries").get()
            .then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    results.push(doc.data())
                });
                resolve({success: results})
            })
            .catch(err=>{
                console.log(err)
                reject({error: err})
            })
        })
    }
}

